/* Sdílený „odesílám…“ stav odesílacích tlačítek.
   Zamkne tlačítko HNED po kliknutí (ještě před reCAPTCHA a AJAXem), takže
   nejde odeslat formulář dvakrát a je vidět, že se něco děje.

   prisahaFormStart(form[, text]) -> true = můžeš pokračovat, false = už se odesílá
   prisahaFormEnd(form)           -> odemkne a vrátí původní popisek */
(function () {
	var VYCHOZI_TEXT = 'Odesílám…';

	function tlacitko(form) {
		return form.querySelector('button[type="submit"], input[type="submit"], button:not([type])');
	}

	function popisek(btn) {
		return btn.tagName === 'INPUT' ? btn.value : btn.textContent;
	}

	function nastavPopisek(btn, text) {
		if (btn.tagName === 'INPUT') {
			btn.value = text;
		} else {
			btn.textContent = text;
		}
	}

	window.prisahaFormStart = function (form, text) {
		if (!form || form.getAttribute('data-odesila') === '1') {
			return false;
		}
		form.setAttribute('data-odesila', '1');
		form.setAttribute('aria-busy', 'true');

		var btn = tlacitko(form);
		if (btn) {
			if (btn.getAttribute('data-puvodni-text') === null) {
				btn.setAttribute('data-puvodni-text', popisek(btn));
			}
			btn.disabled = true;
			btn.classList.add('is-busy');
			nastavPopisek(btn, text || VYCHOZI_TEXT);
		}
		return true;
	};

	window.prisahaFormEnd = function (form) {
		if (!form) {
			return;
		}
		form.removeAttribute('data-odesila');
		form.removeAttribute('aria-busy');

		var btn = tlacitko(form);
		if (btn) {
			btn.disabled = false;
			btn.classList.remove('is-busy');
			var puvodni = btn.getAttribute('data-puvodni-text');
			if (puvodni !== null) {
				nastavPopisek(btn, puvodni);
			}
		}
	};
})();
